import { cookiesStorage } from '$utils/services/cookiesStorage'

export const handleCookiesStatistics = (cookiesStatisticsState: Boolean) => {
  return cookiesStorage.saveCookie('cookiesStatistics', cookiesStatisticsState.toString())
}



// WEBPACK FOOTER //
// ./src/services/user/cookiesStatistics/handleCookiesStatistics.service.ts